import { IAppointmentScheduleResponse, IPatientDetail } from "@curefit/care-common";
import { Goal, UserGoalView } from "@curefit/gmf-common";
import { IMetricData } from "@curefit/metrics-common";
import ILifestyleGoal, { ILifestyleGoalIdealValue } from "../../models/ILifestyleGoal";
import * as _ from "lodash";
import * as React from "react";
import AppUtils from "../../utils/AppUtils";
import { AppConstants, vitalHeaderMap, CheckinType } from "../../utils/AppConstants";
import IDoctorSpeciality from "../../models/IDoctorSpeciality";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import IPatientLifestylePlanWrapper from "../../models/patients/IPatientLifestylePlanWrapper";
import IMealItem from "../../models/IMealItem";
import IMealSlot from "../../models/IMealSlot";
import { IOngoingConsultation } from "../../models/IOngoingConsultation";
import { IPatientVitalResponse } from "../../models/IPatientVitalResponse";
import IMetric from "../../models/metrics/IMetric";
import ChiefComplaintsPlanPDFTemplate from "./planPdfTemplates/ChiefComplaints";
import DiagnosisPlanPDFTemplate from "./planPdfTemplates/Diagnosis";
import DiagnosticAssessmentPlanPDFTemplate from "./planPdfTemplates/DiagnosticAssessment";
import DietGuidelinesPlanPDFTemplate from "./planPdfTemplates/DietGuidelines";
import DietThemesPlanPDFTemplate from "./planPdfTemplates/DietThemes";
import FitnessPlanPDFTemplate from "./planPdfTemplates/FitnessPlan";
import DietPlanPDFTemplate from "./planPdfTemplates/DietPlan";
import ModelFactory from "../../models/ModelFactory";
import { ConsolidatedPlanView } from "@curefit/gmf-common/dist";
import { DocSignatureMap } from "../../containers/Ongoing/ReviewPdf";
import { ORION_IMG_URL } from "../../utils/AppConstants";
import GoalsPdf from "./planPdfTemplates/GoalsPdf";
import HabitPlanPDFTemplate from "./planPdfTemplates/HabitPlan";
import MedicinePlanPDFTemplate from "./planPdfTemplates/MedicinePlanPrescription";
import PatientNoteSetPlanPDFTemplate from "./planPdfTemplates/PatientNoteSet";
import ReferralPlanPDFTemplate from "./planPdfTemplates/Referral";
import { IEHRSavePatientMedicalProfile } from "../../models/patients/IEHRSavePatientMedicalProfile";
import FollowUpPlanPDFTemplate from "./planPdfTemplates/FollowUp";


export class PrescriptionHeader extends React.Component {
    render() {
        return (<div className="prescription-header">
            <img src={ORION_IMG_URL + "prescription-icons/line.png"} alt="line" className="header-line" />
            <div className="prescription-logo">
                <img className="logo" src={ORION_IMG_URL + "care-fit.png"} alt="logo" />
                <img className="logo-image-text" src={ORION_IMG_URL + "carefit-logo-text.svg"} alt="logo" />
            </div>
        </div>);
    }
}
export class PrescriptionFooter extends React.Component<{ consultation: IAppointmentScheduleResponse }, null> {
    render() {
        const { center } = this.props.consultation;
        return (<div className="prescription-footer">
            <div>
                <div className="prescription-heading">
                    {center.name}
                </div>
            </div>
            <div>
                <div className="prescription-description">
                    <span>hello@cure.fit</span>
                    <img className="footer-chat-icon" src={ORION_IMG_URL + "prescription-icons/chat.png"} alt="mail" />
                </div>
            </div>
        </div>);
    }
}

interface LifestylePlanProps {
    patient: IPatientDetail;
    // consultation: IAppointmentScheduleResponse;
    consultation: IAppointmentScheduleResponse;
    id?: string,
    patientMedicalProfileData: IEHRSavePatientMedicalProfile;
    patientPlan: IPatientLifestylePlanWrapper;
    patientGoals: UserGoalView[];
    patientSecondaryGoals: string[]
    hideHeaderFooter: boolean;
    renderHandler?: () => void;
    vitals: IPatientVitalResponse[];
    staticSpecialistData: IDoctorSpeciality[];
    staticLifestyleHabits: IStaticDataValue[];
    staticGoals: Goal[];
    staticMetrics: IMetric[];
    planMeta: ConsolidatedPlanView;
    patientMetrics: { [metricId: number]: IMetricData[] };
    signatureImagePreSignedUrlMap: { [index: string]: DocSignatureMap };
}
interface LifestylePlanStates {
    formattedPlan: any[];
    pdfGenerated: boolean;
}
export default class LifestylePlan extends React.Component<LifestylePlanProps, LifestylePlanStates> {
    cardContainer: any[];
    constructor(props: LifestylePlanProps) {
        super(props);
        this.cardContainer = [];
        this.state = { formattedPlan: this.formatPlan(props), pdfGenerated: false };
    }
    formatPlan = (props: LifestylePlanProps) => {
        let formattedPlan: any[] = [];
        let plan: any = {};

        if (AppUtils.isMindConsultation(props.consultation)) {
            // therapist
            if (props.patientMedicalProfileData.currentConsultationData.chiefComplaints
                && !_.isEmpty(props.patientMedicalProfileData.currentConsultationData.chiefComplaints) || props.patientMedicalProfileData.currentConsultationData.chiefComplaints.doctorPublicNotes && !_.isEmpty(props.patientMedicalProfileData.currentConsultationData.chiefComplaints.doctorPublicNotes.publicNotes)
                || props.patientMedicalProfileData.currentConsultationData.chiefComplaints.presentIllness && props.patientMedicalProfileData.currentConsultationData.chiefComplaints.presentIllness.noPresentingIllness) {
                plan.chiefComplaintsByTherapist = {
                    chiefComplaints: props.patientMedicalProfileData.currentConsultationData.chiefComplaints,
                    publicNotes: null,
                    noPresentingIllness: props.patientMedicalProfileData.currentConsultationData.chiefComplaints.presentIllness &&
                        props.patientMedicalProfileData.currentConsultationData.chiefComplaints.presentIllness.noPresentingIllness
                }
            }

            if (!_.isEmpty(props.patientMedicalProfileData.currentConsultationData.prescriptionDiagnosis)) {
                plan.diagnosisByTherapist = props.patientMedicalProfileData.currentConsultationData.prescriptionDiagnosis;
            }
            if (!_.isEmpty(props.patientMedicalProfileData.currentConsultationData.notesForPatient) && !_.isEmpty(props.patientMedicalProfileData.currentConsultationData.notesForPatient.notes)) {
                plan.patientNoteSet = props.patientMedicalProfileData.currentConsultationData.notesForPatient.notes;
            }

            if (!_.isEmpty(props.patientMedicalProfileData.currentConsultationData.prescriptionInstructions.referralInfoSet) && !_.isEmpty(props.patientMedicalProfileData.currentConsultationData.prescriptionInstructions.referralInfoSet.filter(item => item.checkinType === CheckinType.REFERRAL))) {
                plan.referralsByTherapist = props.patientMedicalProfileData.currentConsultationData.prescriptionInstructions.referralInfoSet && props.patientMedicalProfileData.currentConsultationData.prescriptionInstructions.referralInfoSet.filter(item => item.checkinType === CheckinType.REFERRAL && AppUtils.shouldPrescriptionItemDisplayInPDF(item));
            }
            if (!_.isEmpty(props.patientMedicalProfileData.currentConsultationData.prescriptionInstructions.followupInfoSet) && !_.isEmpty(props.patientMedicalProfileData.currentConsultationData.prescriptionInstructions.followupInfoSet.filter(item => item.checkinType === CheckinType.FOLLOWUP))) {
                plan.followUpsByTherapist = props.patientMedicalProfileData.currentConsultationData.prescriptionInstructions.followupInfoSet && props.patientMedicalProfileData.currentConsultationData.prescriptionInstructions.followupInfoSet.filter(item => item.checkinType === CheckinType.FOLLOWUP && AppUtils.shouldPrescriptionItemDisplayInPDF(item));
            }
            if (!_.isEmpty(plan.chiefComplaintsByTherapist) || !_.isEmpty(plan.hopiByTherapist) || !_.isEmpty(plan.diagnosisByTherapist) ||
                !_.isEmpty(plan.patientNoteSet) || !_.isEmpty(plan.referralsByTherapist) || !_.isEmpty(plan.followUpsByTherapist) ||
                !_.isEmpty(plan.publicNotesByTherapist) || plan.noPresentingIllnessByTherapist)
                formattedPlan.push(plan);

            // psychiatrist
            plan = {};
            if (!_.isEmpty(props.patientMedicalProfileData.currentConsultationData.diagnosticsAssessments)) {
                plan.diagnosticAssessmentByTherapist = props.patientMedicalProfileData.currentConsultationData.diagnosticsAssessments.assessments && props.patientMedicalProfileData.currentConsultationData.diagnosticsAssessments.assessments.filter((item: any) => AppUtils.shouldPrescriptionItemDisplayInPDF(item));
            }
            if (!_.isEmpty(props.patientMedicalProfileData.currentConsultationData.prescriptionMedicines)) {
                plan.medicinePlanPrescriptionByTherapist = props.patientMedicalProfileData.currentConsultationData.prescriptionMedicines && props.patientMedicalProfileData.currentConsultationData.prescriptionMedicines.prescriptionMedicationList.filter(item => AppUtils.shouldPrescriptionItemDisplayInPDF(item));
            }
            if (!_.isEmpty(plan.diagnosticAssessmentByTherapist) || !_.isEmpty(plan.medicinePlanPrescriptionByTherapist)) {
                formattedPlan.push(plan);
            }
            if (plan.hasOwnProperty("mindfulnessPrescription")) {
                formattedPlan.push(plan);
            }
        } else {
            const patientPlan = this.props.patientMedicalProfileData && this.props.patientMedicalProfileData.patientData && this.props.patientMedicalProfileData.patientData.newConfigData ? this.props.patientMedicalProfileData.patientData.newConfigData : {};
            let newVitals = AppUtils.getRecentVitals(this.props.vitals, 2);
            if (newVitals && newVitals.length > 0) {
                plan.vitals = newVitals;
                formattedPlan.push(plan);
            }

            plan = {};
            if (!_.isEmpty(props.patientGoals)) {
                plan.primaryGoals = props.patientGoals;
            }
            if (!_.isEmpty(props.patientSecondaryGoals)) {
                plan.secondaryGoals = props.patientSecondaryGoals;
            }
            if (!_.isEmpty(plan.primaryGoals) || !_.isEmpty(plan.secondaryGoals)) {
                formattedPlan.push(plan);
            }

            if (!_.isEmpty(patientPlan)) {
                plan = {};
                const requiredDiets = !_.isEmpty(patientPlan.dietPlan) ? patientPlan.dietPlan : null;
                if (requiredDiets && !_.isEmpty(requiredDiets.guidelines)) {
                    const doGuidelines = requiredDiets.guidelines.filter((item: any) => item.type === "DO");
                    const dontGuidelines = requiredDiets.guidelines.filter((item: any) => item.type === "DONT");
                    if (!_.isEmpty(doGuidelines)) {
                        plan.dietDoGuidelines = doGuidelines;
                    } if (!_.isEmpty(dontGuidelines)) {
                        plan.dietDontGuidelines = dontGuidelines;
                    }
                }
                // plan.dietPrescription = requiredDiets[0];
                if (!_.isEmpty(requiredDiets) && !_.isEmpty(requiredDiets.meals)) {
                    plan.mealSlots = AppUtils.sortMealsByTime(requiredDiets.meals);
                    _.map(requiredDiets.meals, (mealItem: IMealSlot) => {
                        plan["meal-slot-" + mealItem.mealSlot] = [];
                        plan["meal-slot-" + mealItem.mealSlot].push(mealItem);
                        plan["meal-slot-" + mealItem.mealSlot] = plan["meal-slot-" + mealItem.mealSlot].concat(mealItem.details.mealIds.map((item, index) => { return { index, item } }));
                    })
                }
                // let totalCaloriesPerDay = !_.isEmpty(requiredDiets) && !_.isEmpty(requiredDiets[0].meals) ?
                //     AppUtils.calculateTotalCaloriesInADay(requiredDiets[0].meals) : 0;
                // plan.totalCalories = totalCaloriesPerDay;

                let overallThemes = !_.isEmpty(requiredDiets) && !_.isEmpty(requiredDiets.themes) ? requiredDiets.themes : [];
                plan.overallThemes = overallThemes;
                formattedPlan.push(plan);

                plan = {};
                if (!_.isEmpty(patientPlan.fitnessPlan)) {
                    let guidelinesList = !_.isEmpty(patientPlan.fitnessPlan.guidelines) ? patientPlan.fitnessPlan.guidelines : [];
                    let fitnessActivities = !_.isEmpty(patientPlan.fitnessPlan.activities) ? patientPlan.fitnessPlan.activities : [];
                    plan.fitnessPrescription = guidelinesList.concat(fitnessActivities);
                }
                if (!_.isEmpty(patientPlan.mindfulnessPlan)) {
                    let mindGuidelinesList = !_.isEmpty(patientPlan.mindfulnessPlan.guidelines) ? patientPlan.mindfulnessPlan.guidelines : [];
                    let mindfulnessActivities = !_.isEmpty(patientPlan.mindfulnessPlan.activities) ? patientPlan.mindfulnessPlan.activities : [];
                    plan.mindfulnessPrescription = mindGuidelinesList.concat(mindfulnessActivities);
                }
                if (!_.isEmpty(patientPlan.habits) && !_.isEmpty(patientPlan.habits.habitList)) {
                    let habitItems = [];
                    let smokingHabits = patientPlan.habits.habitList.filter((item: any) => item.dailyHabit.internalValue.toLowerCase().indexOf("smoking") !== -1);
                    if (smokingHabits.length > 0) habitItems.push(smokingHabits[0]);
                    let waterHabits = patientPlan.habits.habitList.filter((item: any) => item.dailyHabit.internalValue.toLowerCase().indexOf("water") !== -1);
                    if (waterHabits.length > 0) habitItems.push(waterHabits[0]);
                    let alcoholHabits = patientPlan.habits.habitList.filter((item: any) => item.dailyHabit.internalValue.toLowerCase().indexOf("alcohol") !== -1);
                    if (alcoholHabits.length > 0) habitItems.push(alcoholHabits[0]);

                    if (habitItems.length === 1) habitItems.push("FILLER-BIG");
                    else if (habitItems.length === 2) habitItems.push("FILLER-SMALL");
                    plan.habitsPrescription = { habitItems };
                }
                if (!_.isEmpty(patientPlan.prescriptionInstructions) && !_.isEmpty(patientPlan.prescriptionInstructions.referralInfoSet)) {
                    plan.referralsByLC = patientPlan.prescriptionInstructions.referralInfoSet;
                }
                if (!_.isEmpty(patientPlan.prescriptionInstructions) && !_.isEmpty(patientPlan.prescriptionInstructions.followupInfoSet)) {
                    plan.followUpsByLC = patientPlan.prescriptionInstructions.followupInfoSet;
                }
                if (plan.hasOwnProperty("fitnessPrescription")
                    || plan.hasOwnProperty("habitsPrescription")
                    || plan.hasOwnProperty("referralsByLC")
                    || plan.hasOwnProperty("followUpsByLC")) {
                    formattedPlan.push(plan);
                }
            }

        }

        return formattedPlan;
    }
    componentDidMount() {
        if (this.cardContainer[0] && this.cardContainer[0].clientHeight <= AppConstants.DIET_PLAN_MAX_HEIGHT && this.cardContainer[1] && this.cardContainer[1].clientHeight <= AppConstants.DIET_PLAN_MAX_HEIGHT) {
            if (this.props.renderHandler && typeof this.props.renderHandler === "function") {
                this.props.renderHandler();
            }
        } else {
            let formattedPlan: any[] = [];
            let patientPlan = [...this.state.formattedPlan];
            _.map(patientPlan, (plan, index) => {
                let updatedPatientPlan = AppUtils.formatPDFPages(plan, this.cardContainer[index],
                    AppConstants.PLAN_PRESCRIPTION_MAX_HEIGHT, 40);
                formattedPlan = formattedPlan.concat(updatedPatientPlan);
            })
            this.setState({ formattedPlan: formattedPlan });
        }
    }
    componentDidUpdate() {
        if (!this.state.pdfGenerated) {
            if (this.props.renderHandler && typeof this.props.renderHandler === "function") {
                this.props.renderHandler();
                this.setState({ pdfGenerated: true })
            }
        }
    }
    headerDecider = (plan: any) => {
        let header = "LIFESTYLE PLAN";
        if (!_.isEmpty(plan.primaryGoals) || !_.isEmpty(plan.secondaryGoals)) {
            header = "GOALS";
        } else if (!_.isEmpty(plan.chiefComplaintsByTherapist) || !_.isEmpty(plan.diagnosisByTherapist) || !_.isEmpty(plan.patientNoteSet) ||
            !_.isEmpty(plan.medicinePlanPrescriptionByTherapist) || !_.isEmpty(plan.referralsByTherapist) || !_.isEmpty(plan.followUpsByTherapist) || !_.isEmpty(plan.diagnosticAssessmentByTherapist) || !_.isEmpty(plan.publicNotesByTherapist) || plan.noPresentingIllnessByTherapist) {
            header = "MIND PLAN";
        } else if (!_.isEmpty(plan.diagnosticPrescription) || !_.isEmpty(plan.medicinePrescription) || !_.isEmpty(plan.chiefComplaints)
            || !_.isEmpty(plan.diagnosis) || !_.isEmpty(plan.referrals) || !_.isEmpty(plan.followUps) || !_.isEmpty(plan.doctorAdvicePrescriptionSet) || !_.isEmpty(plan.publicNotes) || plan.noPresentingIllness) {
            header = "CLINICAL PLAN";
        } else if (!_.isEmpty(plan.dietPrescription)) {
            header = "DIET PLAN";
        } else if (!_.isEmpty(plan.vitals)) {
            header = "ABOUT ME";
        } else {
            let keys = Object.keys(plan);
            _.map(keys, (key: string) => {
                if (key.startsWith("meal-slot")) {
                    header = "DIET PLAN";
                    return false;
                }
            })
        }
        return header;
    }
    getDoctorTypeLabel = (doctorType: string): string => {
        let label = "DOCTOR";
        if (doctorType === "LC") label = "COACH";
        else if (doctorType === "MIND_THERAPIST") label = "THERAPIST";
        return label;
    }
    getAuthorObject = (plan: any) => {
        let consultation = this.props.consultation;
        let currentDoctor = this.props.consultation.doctor;
        let author = ModelFactory.createNewAuthorObj(currentDoctor.name, this.getDoctorTypeLabel(consultation.consultationProduct.subServiceType), currentDoctor.signatureImage, currentDoctor.registrationNumber, currentDoctor.id.toString());
        let sourceFamilyMap = !_.isEmpty(this.props.planMeta) && !_.isEmpty(this.props.planMeta.planMeta) && !_.isEmpty(this.props.planMeta.planMeta.planSourceMeta) ?
            this.props.planMeta.planMeta.planSourceMeta : null;
        let header = this.headerDecider(plan);
        if (header === "LIFESTYLE PLAN") {
            if (!AppUtils.isLifeStyleConsultation(consultation)) {
                if (!_.isNull(sourceFamilyMap) && sourceFamilyMap.hasOwnProperty("LIFESTYLE")) {
                    let coach = sourceFamilyMap.LIFESTYLE;
                    author = ModelFactory.createNewAuthorObj(coach.sourceName, "COACH", coach.signatureImage, null, coach.serviceId);
                } else if (!_.isNull(sourceFamilyMap) && sourceFamilyMap.hasOwnProperty("THERAPIST")) {
                    let reqDoctor = sourceFamilyMap.THERAPIST;
                    let doctorLabelToShow = "THERAPIST";
                    author = ModelFactory.createNewAuthorObj(reqDoctor.sourceName, doctorLabelToShow, reqDoctor.signatureImage, reqDoctor.registrationNumber, reqDoctor.serviceId);
                } else if (!_.isNull(sourceFamilyMap) && sourceFamilyMap.hasOwnProperty("THERAPIST")) {
                    let reqDoctor = sourceFamilyMap.THERAPIST;
                    let doctorLabelToShow = "THERAPIST";
                    author = ModelFactory.createNewAuthorObj(reqDoctor.sourceName, doctorLabelToShow, reqDoctor.signatureImage, reqDoctor.registrationNumber, reqDoctor.serviceId);
                } else {
                    author = ModelFactory.createNewAuthorObj(currentDoctor.name, this.getDoctorTypeLabel(consultation.consultationProduct.subServiceType), currentDoctor.signatureImage, currentDoctor.registrationNumber, currentDoctor.id.toString());
                }
            }
        } else if (header === "MIND PLAN") {
        } else if (header === "CLINICAL PLAN") {
            if (AppUtils.isMindConsultation(consultation) || AppUtils.isLifeStyleConsultation(consultation)) {
                if (!_.isNull(sourceFamilyMap) && sourceFamilyMap.hasOwnProperty("DOCTOR")) {
                    let doctor = sourceFamilyMap.DOCTOR;
                    author = ModelFactory.createNewAuthorObj(doctor.sourceName, "DOCTOR", doctor.signatureImage, doctor.registrationNumber, doctor.serviceId);
                }
            }
        } else if (header === "DIET PLAN") {
            if (!AppUtils.isLifeStyleConsultation(consultation)) {
                if (!_.isNull(sourceFamilyMap) && sourceFamilyMap.hasOwnProperty("LIFESTYLE")) {
                    let coach = sourceFamilyMap.LIFESTYLE;
                    author = ModelFactory.createNewAuthorObj(coach.sourceName, "COACH", coach.signatureImage, null, coach.serviceId);
                }
            }
        }
        return author;

    }

    formatPatientNameForPDF = (name: string) => {
        let formattedName = name;
        if (name.length > 25) {
            let firstName = name.split(" ")[0].length < 26 ? name.split(" ")[0] : name.substring(0, 22) + "...";
            let lastName = name.split(" ")[1] !== undefined ? name.split(" ")[1].charAt(0).toUpperCase() : "";
            formattedName = `${firstName} ${firstName.endsWith("...") ? "" : lastName}`;
        }
        return formattedName;
    }

    _getNextMonthEpochObj = (monthsArr: any[]) => {
        let max_num = Number.MAX_SAFE_INTEGER;
        let currentEpoch = new Date().getTime();
        let result = null;
        for (let i = 0; i < monthsArr.length; i++) {
            let epoch = monthsArr[i].targetEpoch;
            if (epoch > currentEpoch && epoch < max_num) {
                max_num = epoch;
                result = monthsArr[i];
            }
        }
        /* Fix for no next milestone - return null value */
        if (_.isNull(result)) result = { value: null };
        return result;
    };

    _getTargetObj = (targetsArr: any[]) => {
        let min_num = 0;
        let result = null;
        for (let i = 0; i < targetsArr.length; i++) {
            let targetEpoch = targetsArr[i].targetEpoch;
            if (targetEpoch > min_num) {
                min_num = targetEpoch;
                result = targetsArr[i];
            }
        }
        return result;
    };

    _getLatestMetric = (metricId: string, currentValue: ILifestyleGoalIdealValue) => {
        let now = new Date().getTime();
        let metric = AppUtils.isDefined(this.props.patientMetrics) ? this.props.patientMetrics[metricId as any] : null;
        let result = null, min = 0;
        if (AppUtils.isDefined(metric) && metric.length > 0) {
            for (let i = 0; i < metric.length; i++) {
                let epoch = metric[i].metricDate;
                if (epoch > min && epoch < now) {
                    min = epoch;
                    result = metric[i];
                }
            }
            return Number(result.value);
        } else if (!_.isEmpty(currentValue) && currentValue.value) {
            return Number(currentValue.value);
        } else {
            return null;
        }
    };

    _getDisplayRangeMinValue = (goalMetric: ILifestyleGoal) => {
        const metricArr = Object.values(this.props.staticMetrics);
        let metric = metricArr.find((metric: IMetric) => metric.id === goalMetric.metricId);
        const hasMetricIdealRange = AppUtils.isDefined(goalMetric.idealValue) && AppUtils.isDefined(goalMetric.idealValue.range);
        if (AppUtils.isDefined(metric) && AppUtils.isDefined(metric.rangeBuckets) && metric.rangeBuckets.length > 0) {
            let { rangeBuckets } = metric;
            let value = hasMetricIdealRange ? Number(goalMetric.idealValue.range.min) : 0;
            let matchedBucket = rangeBuckets.find((bucket: any) => {
                return (value <= bucket.rangeMax && value >= bucket.rangeMin)
            });
            if (AppUtils.isDefined(matchedBucket))
                return matchedBucket.displayLabel
            else if (hasMetricIdealRange)
                return goalMetric.idealValue.range.min
            else
                return null
        } else {
            if (hasMetricIdealRange)
                return goalMetric.idealValue.range.min
            else
                return null
        }
    };

    _getDisplayRangeMaxValue = (goalMetric: ILifestyleGoal) => {
        const metricArr = Object.values(this.props.staticMetrics);
        let metric = metricArr.find((metric: IMetric) => metric.id === goalMetric.metricId);
        const hasMetricIdealRange = AppUtils.isDefined(goalMetric.idealValue) && AppUtils.isDefined(goalMetric.idealValue.range);
        if (AppUtils.isDefined(metric) && AppUtils.isDefined(metric.rangeBuckets) && metric.rangeBuckets.length > 0) {
            let { rangeBuckets } = metric;
            let value = hasMetricIdealRange ? Number(goalMetric.idealValue.range.max) : 0;
            let matchedBucket = rangeBuckets.find((bucket: any) => {
                return (value <= bucket.rangeMax && value >= bucket.rangeMin)
            });
            if (AppUtils.isDefined(matchedBucket))
                return matchedBucket.displayLabel
            else if (hasMetricIdealRange)
                return goalMetric.idealValue.range.max
            else
                return null
        } else {
            if (hasMetricIdealRange)
                return goalMetric.idealValue.range.max
            else
                return null
        }
    };

    _getDisplayCurrentValue = (goalMetric: ILifestyleGoal) => {
        const metricArr = Object.values(this.props.staticMetrics);
        let metric = metricArr.find((metric: IMetric) => metric.id === goalMetric.metricId);
        let value = this._getLatestMetric(goalMetric.metricId, goalMetric.currentValue);
        if (AppUtils.isDefined(metric) && AppUtils.isDefined(metric.rangeBuckets) && metric.rangeBuckets.length > 0) {
            let { rangeBuckets } = metric;
            let matchedBucket = rangeBuckets.find((bucket: any) => {
                return (value <= bucket.rangeMax && value >= bucket.rangeMin)
            });
            if (AppUtils.isDefined(matchedBucket))
                return matchedBucket.displayLabel
            else if (AppUtils.isDefined(value))
                return value
            else
                return null
        } else {
            return value
        }
    };

    _getDisplayValue = (goalMetric: ILifestyleGoal, targetValue: number) => {
        const metricArr = Object.values(this.props.staticMetrics);
        let metric = metricArr.find((metric: IMetric) => metric.id === goalMetric.metricId);
        if (AppUtils.isDefined(metric) && AppUtils.isDefined(metric.rangeBuckets) && metric.rangeBuckets.length > 0) {
            let { rangeBuckets } = metric;
            let matchedBucket = rangeBuckets.find(bucket => {
                return (AppUtils.isDefined(targetValue) && targetValue <= bucket.rangeMax && targetValue >= bucket.rangeMin)
            });
            if (AppUtils.isDefined(matchedBucket))
                return matchedBucket.displayLabel
            else if (AppUtils.isDefined(targetValue))
                return targetValue
            else
                return null
        } else {
            return targetValue
        }
    };

    getAllMealSlots = () => {
        let requiredDiets = this.props.patientMedicalProfileData && this.props.patientMedicalProfileData.patientData && this.props.patientMedicalProfileData.patientData.newConfigData && this.props.patientMedicalProfileData.patientData.newConfigData.dietPlan ? this.props.patientMedicalProfileData.patientData.newConfigData.dietPlan : {};
        return !_.isEmpty(requiredDiets) ? requiredDiets.meals : null;
    }

    getAuthorSignature = (author: any) => {
        if (AppUtils.isDefined(author) && AppUtils.isDefined(this.props.signatureImagePreSignedUrlMap)) {
            const signedUrlObj = this.props.signatureImagePreSignedUrlMap[author.serviceId];
            return signedUrlObj ? signedUrlObj.url : null;
        }
        return null;
    }

    render() {
        let { consultation, hideHeaderFooter } = this.props;
        let id = !_.isEmpty(this.props.id) ? this.props.id : "patient-plan-template";
        let date = consultation && AppUtils.getDayEpochInfo(consultation.startTime);
        let recordedDate: any = this.props.consultation.patient.recordedBirthDate;
        let recordedAge: any = this.props.consultation.patient.recordedAge;
        let patientAge = AppUtils.getAgeToDisplay(this.props.patient.formattedAge);
        let gender = this.props.patient.gender || "";

        return <div className="prescription-template-container" id="printThis">
            {this.state.formattedPlan && this.state.formattedPlan.map((planItem: any, index: number) => {
                let author = this.getAuthorObject(planItem);
                const signatureUrl = this.getAuthorSignature(author);
                return <div className={id} key={index}>
                    <div className={"patient-plan-template-wrapper"}>
                        {!hideHeaderFooter && <PrescriptionHeader />}
                        <div className="plan-type-header">
                            <span className={"brandon-bold"}>{this.headerDecider(planItem)}</span>
                        </div>
                        <div className="patient-prescription-body">
                            <div className="prescription-card">
                                <div className="prescription-card-header">
                                    <div className={"prescription-card-header-item name-header-container"}>
                                        <div className={"prescription-card-header-item-label"}>FOR</div>
                                        <div className={"prescription-card-header-item-value"}>
                                            {this.formatPatientNameForPDF(consultation.patient.name)}
                                            {!_.isEmpty(patientAge) ? <span className={"patient-age"}>{patientAge}</span> : ""}
                                        </div>
                                    </div>
                                    <div className={"prescription-card-header-item gender-header-container"}>
                                        <div className={"prescription-card-header-item-label"}>GENDER</div>
                                        <div className={"prescription-card-header-item-value"}>{consultation.patient.gender}</div>
                                    </div>
                                    {/* <div className={"prescription-card-header-item contact-header-container"}>
                                        <div className={"prescription-card-header-item-label"}>CONTACT</div>
                                        <div className={"prescription-card-header-item-value"}>{consultation.patient.phoneNumber}</div>
                                    </div> */}
                                    <div className={"prescription-card-header-item doctor-header-container"}>
                                        <div className={"prescription-card-header-item-label"}>{author.label}</div>
                                        <div className={"prescription-card-header-item-value"}>{author.name}</div>
                                    </div>
                                </div>
                                <span className="prescription-card-content-container" ref={(cardContainer) => this.cardContainer.push(cardContainer)}>
                                    {planItem.vitals && planItem.vitals.length > 0 && <div id={"vitals"} className="prescription-grid-row external-row">
                                        <div className="prescription-card-content">
                                            <div id={"vitals-subsection"} className="prescription-description">
                                                <div className={"vital-filler-image"}>
                                                    {
                                                        gender.toLowerCase() === "male" &&
                                                        <img src={ORION_IMG_URL + "vital-male-filler.svg"} />
                                                    }
                                                    {
                                                        gender.toLowerCase() === "female" &&
                                                        <img src={ORION_IMG_URL + "vital-female-filler.svg"} />
                                                    }
                                                    {
                                                        gender.toLowerCase() !== "male" && gender.toLowerCase() !== "female" &&
                                                        <img src={ORION_IMG_URL + "vital-male-filler.svg"} />
                                                    }
                                                </div>
                                                <div className="vital-values-container">
                                                    {planItem.vitals.map((vital: any, index: number) => {
                                                        let vitalUnitText = !_.isEmpty(vital.unit) ? ` ( ${vital.unit} )` : "";
                                                        return <div className="vital-row" key={index}>
                                                            <div className={"vital-image-container"}>
                                                                <img src={AppUtils.getVitalIcon(vital.vitalName.toUpperCase())} />
                                                            </div>
                                                            <div className={"vital-value-container"}>
                                                                <div className="vital-header-name">{`${vitalHeaderMap[vital.vitalName.toUpperCase()]} ${vitalUnitText}`}</div>
                                                                {vital.vital && <div className="patient-vital-value brandon-bold">
                                                                    {vital.vital.value}
                                                                </div>}
                                                            </div>
                                                        </div>
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                    {/* Goals Section */}
                                    {
                                        !_.isEmpty(planItem.primaryGoals) && <div id={"primaryGoals"} className={`prescription-grid-row external-row`}>
                                            <div className="prescription-card-content">
                                                <GoalsPdf goals={planItem.primaryGoals} />
                                                {/*<div className="diagnostic-header brandon-bold"><img src="/images/icons/lab-test-header-icon.svg" className={"header-icon"} /> LAB TESTS</div>*/}
                                                {/*<div id={"primaryGoals-subsection"} className="prescription-description">*/}
                                                {/*{_.map(planItem.primaryGoals, (patientGoal: UserGoalView, index: number) => {*/}
                                                {/*// return <GoalsPdf/>*/}
                                                {/*return <div key={`${patientGoal}-${index}`} className={"primaryGoal-item"}>*/}
                                                {/*<div>*/}
                                                {/*<div className={"goal-name brandon-bold"}>{AppUtils.getGoalIdFromGoalName(patientGoal.goalId, this.props.staticGoals).toUpperCase()}</div>*/}
                                                {/*<div className={"goal-metrics-container"}>*/}
                                                {/*{*/}
                                                {/*_.map(patientGoal.goalMetricTargets, (goalMetric: ILifestyleGoal) => {*/}
                                                {/*const rangeMin = AppUtils.isDefined(goalMetric.idealValue) && AppUtils.isDefined(goalMetric.idealValue.range) ? Number(goalMetric.idealValue.range.min) : 0;*/}
                                                {/*const rangeMax = AppUtils.isDefined(goalMetric.idealValue) && AppUtils.isDefined(goalMetric.idealValue.range) ? Number(goalMetric.idealValue.range.max) : 0;*/}
                                                {/*const currentValue = goalMetric.currentValue ? Number(goalMetric.currentValue.value) : null;*/}
                                                {/*const displayRangeMin = this._getDisplayRangeMinValue(goalMetric);*/}
                                                {/*const displayRangeMax = this._getDisplayRangeMaxValue(goalMetric);*/}
                                                {/*const displayCurrentValue = this._getDisplayCurrentValue(goalMetric);*/}
                                                {/*const nextMilestoneObj = this._getNextMonthEpochObj(goalMetric.targets);*/}
                                                {/*// const targetObj = this._getTargetObj(goalMetric.targets);*/}
                                                {/*const targetObj = goalMetric.idealValue;*/}
                                                {/*const currentUpdatedValue = this._getLatestMetric(goalMetric.metricId, goalMetric.currentValue);*/}
                                                {/*const goalTargetValue = !_.isEmpty(targetObj) ? targetObj.value : null;*/}
                                                {/*const goalTargetDisplayValue = !_.isEmpty(targetObj) ? this._getDisplayValue(goalMetric, targetObj.value) : null;*/}
                                                {/*const displayInitialValue = this._getDisplayValue(goalMetric, currentValue);*/}
                                                {/*const displayMilestoneValue = !_.isEmpty(nextMilestoneObj) ? this._getDisplayValue(goalMetric, nextMilestoneObj.value) : null;*/}
                                                {/*const goalValueClass = typeof displayInitialValue === "string" || typeof displayCurrentValue === "string" || typeof displayMilestoneValue === "string" || typeof goalTargetDisplayValue === "string" ? "goal-value-string" : "";*/}
                                                {/*const goalValueContainerCls = goalValueClass.length > 0 && !AppUtils.isDefined(goalTargetDisplayValue) ? "less-padding" : "";*/}
                                                {/*return <div className={"goal-metric-container"}>*/}
                                                {/*//                         <div className={"metric-name brandon-bold"}>{AppUtils.getMetricNameFromMetricId(goalMetric.metricId, this.props.staticMetrics)}</div>*/}
                                                {/*//                         <div className={"metric-values"}>*/}
                                                {/*//                             <GoalsMetricBar range={{min: rangeMin, max: rangeMax}} displayMin={displayRangeMin as any} displayMax={displayRangeMax as any} displayCurrent={displayCurrentValue as any} currentUpdatedValue={currentUpdatedValue} targetValue={goalTargetValue} targetDisplayValue={goalTargetDisplayValue} />*/}
                                                {/*//                             <div className={"goal-values-container"}>*/}
                                                {/*//                                 <div className={"goal-value-container " + goalValueContainerCls}>*/}
                                                {/*//                                     <p className={"goal-value-header"}>Initial</p>*/}
                                                {/*//                                     <span className={"goal-value " + goalValueClass}>{displayInitialValue}</span>*/}
                                                {/*//                                 </div>*/}
                                                {/*//                                 <div className={"goal-value-container " + goalValueContainerCls}>*/}
                                                {/*//                                     <p className={"goal-value-header"}>Current</p>*/}
                                                {/*//                                     <span className={"goal-value " + goalValueClass}>{displayCurrentValue}</span>*/}
                                                {/*//                                 </div>*/}
                                                {/*//                                 <div className={"goal-value-container " + goalValueContainerCls}>*/}
                                                {/*//                                     <p className={"goal-value-header"}>Next Milestone</p>*/}
                                                {/*//                                     <span className={"goal-value " + goalValueClass}>{displayMilestoneValue}</span>*/}
                                                {/*//                                 </div>*/}
                                                {/*//                                 <div className={"goal-value-container " + goalValueContainerCls}>*/}
                                                {/*//                                     <p className={"goal-value-header"}>Target</p>*/}
                                                {/*<span className={"goal-value " + goalValueClass}>*/}
                                                {/*{AppUtils.isDefined(goalTargetDisplayValue) ? goalTargetDisplayValue : displayRangeMin === displayRangeMax ? `${displayRangeMin}` : `${displayRangeMin}-${displayRangeMax}`}*/}
                                                {/*</span>*/}
                                                {/*</div>*/}
                                                {/*</div>*/}
                                                {/*</div>*/}
                                                {/*</div>*/}
                                                {/*})*/}
                                                {/*}*/}
                                                {/*</div>*/}
                                                {/*</div>*/}
                                                {/*</div>*/}
                                                {/*})}*/}
                                                {/*</div>*/}
                                            </div>
                                        </div>
                                    }
                                    {
                                        !_.isEmpty(planItem.secondaryGoals) && <div id={"secondaryGoals"} className={`prescription-grid-row external-row`}>
                                            <div className="prescription-card-content">
                                                <h4 className="secondaryGoals-header brandon-bold">TOP INTERVENTIONS</h4>
                                                <div id={"secondaryGoals-subsection"} className="prescription-description">
                                                    {_.map(planItem.secondaryGoals, (patientGoal: string, index) => {
                                                        return <div key={`patient-secondary-goal-${index}`} className={"secondaryGoal-item"}>
                                                            <div>
                                                                <div className={"goal-name"}>{patientGoal}</div>
                                                            </div>
                                                        </div>
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {/* Mind Plan Section */}
                                    {
                                        !_.isEmpty(planItem.chiefComplaintsByTherapist) &&
                                        <ChiefComplaintsPlanPDFTemplate id={"chiefComplaintsByTherapist"} planItem={planItem} />
                                    }
                                    {
                                        !_.isEmpty(planItem.diagnosisByTherapist) &&
                                        <DiagnosisPlanPDFTemplate id={"diagnosisByTherapist"} planItem={planItem} />
                                    }
                                    {
                                        !_.isEmpty(planItem.patientNoteSet) &&
                                        <PatientNoteSetPlanPDFTemplate id={"patientNoteSet"} planItem={planItem} />
                                    }
                                    {
                                        !_.isEmpty(planItem.diagnosticAssessmentByTherapist) &&
                                        <DiagnosticAssessmentPlanPDFTemplate id={"diagnosticAssessmentByTherapist"} planItem={planItem} />
                                    }
                                    {
                                        !_.isEmpty(planItem.medicinePlanPrescriptionByTherapist) &&
                                        <MedicinePlanPDFTemplate id={"medicinePlanPrescriptionByTherapist"} planItem={planItem} showDate={true}
                                            includeBorder={!_.isEmpty(planItem.referralsByTherapist) || !_.isEmpty(planItem.followUpsByTherapist)} />
                                    }

                                    {/* Clinical Plan Section */}
                                    {
                                        !_.isEmpty(planItem.chiefComplaints) &&
                                        <ChiefComplaintsPlanPDFTemplate id={"chiefComplaints"} planItem={planItem} />
                                    }
                                    {
                                        !_.isEmpty(planItem.diagnosis) &&
                                        <DiagnosisPlanPDFTemplate id={"diagnosis"} planItem={planItem} />
                                    }
                                    {
                                        !_.isEmpty(planItem.diagnosticPrescription) &&
                                        <DiagnosticAssessmentPlanPDFTemplate id={"diagnosticPrescription"} planItem={planItem} />
                                    }
                                    {
                                        !_.isEmpty(planItem.medicinePrescription) &&
                                        <MedicinePlanPDFTemplate id={"medicinePrescription"} planItem={planItem}
                                            includeBorder={!_.isEmpty(planItem.referrals) || !_.isEmpty(planItem.followUps)} />
                                    }

                                    {
                                        planItem.doctorAdvicePrescriptionSet &&
                                        <div id={"doctorAdvicePrescriptionSet"} className="prescription-grid-row external-row" style={{ marginTop: 15 }}>
                                            <div className="purple-dot" />
                                            <div className="prescription-card-content">
                                                <div className="prescription-sec-heading">Advice</div>
                                                <div id={"doctorAdvicePrescriptionSet-subsection"}>
                                                    {planItem.doctorAdvicePrescriptionSet.map((advice: any, index: number) => {
                                                        return <div key={index}>
                                                            <span className="prescription-subheading">{advice.name}&nbsp;</span>
                                                            {advice.instruction && <span className="prescription-description">-&nbsp;{advice.instruction}</span>}
                                                        </div>
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {/*Diet section*/}
                                    {
                                        !_.isEmpty(planItem.dietDoGuidelines) &&
                                        <DietGuidelinesPlanPDFTemplate id={"dietDoGuidelines"} planItem={planItem} imageUrl={ORION_IMG_URL + "do.svg"}
                                            includeBorder={planItem.hasOwnProperty("dietDontGuidelines") || planItem.hasOwnProperty("totalCalories") || planItem.hasOwnProperty("overallThemes")} />
                                    }
                                    {
                                        !_.isEmpty(planItem.dietDontGuidelines) &&
                                        <DietGuidelinesPlanPDFTemplate id={"dietDontGuidelines"} planItem={planItem} imageUrl={ORION_IMG_URL + "dont.svg"}
                                            includeBorder={planItem.hasOwnProperty("totalCalories") || planItem.hasOwnProperty("overallThemes")} />
                                    }
                                    {
                                        !_.isEmpty(planItem.overallThemes) &&
                                        <DietThemesPlanPDFTemplate id={"overallThemes"} planItem={planItem} />
                                    }
                                    {/*{*/}
                                    {/*planItem.totalCalories !== undefined && planItem.totalCalories > 0 &&*/}
                                    {/*<div id="totalCalories">*/}
                                    {/*<div className={"calories-per-day-container brandon-bold"}>Calories per day <span className={"brandon-bold calories-per-day-value"}>{planItem.totalCalories} kcal</span></div>*/}
                                    {/*</div>*/}
                                    {/*}*/}
                                    {/*Meal Slots*/}
                                    {
                                        _.map(planItem, (mealItem: IMealItem, key: string) => {
                                            if (key.toString().startsWith("meal-slot-")) {
                                                return <DietPlanPDFTemplate id={key} mealItems={mealItem} mealSlots={this.getAllMealSlots()} key={key} />
                                            }
                                        })
                                    }
                                    {/*Fitness section*/}
                                    {
                                        planItem.fitnessPrescription && planItem.fitnessPrescription.length > 0 &&
                                        <FitnessPlanPDFTemplate id={"fitnessPrescription"} planItem={planItem} iconImage={"fitness-plan-image.svg"} header={"FITNESS"} />
                                    }
                                    {/*Mindfulness section*/}
                                    {
                                        planItem.mindfulnessPrescription && planItem.mindfulnessPrescription.length > 0 &&
                                        <FitnessPlanPDFTemplate id={"mindfulnessPrescription"} planItem={planItem} iconImage={"mindfulness-plan-image.svg"} header={"MINDFULNESS"} />
                                    }
                                    {/*Habits section*/}
                                    {
                                        planItem.habitsPrescription && planItem.habitsPrescription.habitItems.length > 0 &&
                                        <HabitPlanPDFTemplate id={"habitsPrescription"} planItem={planItem} />
                                    }
                                    {
                                        planItem.referrals &&
                                        <ReferralPlanPDFTemplate id={"referrals"} planItem={planItem} includeBorder={!_.isEmpty(planItem.followUps)} staticDoctorTypes={this.props.staticSpecialistData} />
                                    }
                                    {
                                        planItem.followUps &&
                                        <FollowUpPlanPDFTemplate id={"followUps"} planItem={planItem} />
                                    }
                                    {
                                        planItem.referralsByTherapist &&
                                        <ReferralPlanPDFTemplate id={"referralsByTherapist"} planItem={planItem}
                                            includeBorder={!_.isEmpty(planItem.followUpsByTherapist)} staticDoctorTypes={this.props.staticSpecialistData} />
                                    }
                                    {
                                        planItem.followUpsByTherapist &&
                                        <FollowUpPlanPDFTemplate id={"followUpsByTherapist"} planItem={planItem} />
                                    }
                                    {
                                        planItem.referralsByLC &&
                                        <ReferralPlanPDFTemplate id={"referralsByLC"} planItem={planItem}
                                            includeBorder={!_.isEmpty(planItem.followUpsByLC)} staticDoctorTypes={this.props.staticSpecialistData} />
                                    }
                                    {
                                        planItem.followUpsByLC &&
                                        <FollowUpPlanPDFTemplate id={"followUpsByLC"} planItem={planItem} />
                                    }
                                </span>
                                {/*<div className="prescription-page-index">Page :&nbsp;&#10222;&nbsp;{index + 1} / {this.state.formattedPlan.length}&nbsp;&#10223;</div>*/}
                            </div>
                            {AppUtils.isDefined(signatureUrl) &&
                                <div className="move-right prescription-description signature-container">
                                    <img src={signatureUrl} alt="signature" className="signature-img" />
                                    {AppUtils.isDefined(author.kmc) &&
                                        <div className={"signature-text"}>{`KMC #: ${author.kmc}`}</div>
                                    }
                                </div>
                            }
                        </div>
                        {!hideHeaderFooter && <PrescriptionFooter consultation={this.props.consultation} />}
                    </div>
                </div>
            })}
        </div>
    }
}
